/* eslint-disable */
import moment from "moment";
import React from "react";
import Badge from "react-bootstrap/Badge";
import Form from "react-bootstrap/Form";
import "react-toastify/dist/ReactToastify.css";

const PaymentItems = (props) => {
  const { element } = props;
  return (
    <>
      <tr>
        <td className="text-capitalize">
          {element.payment_intent ? element?.payment_intent : "-"}
        </td>
        <td className="text-capitalize">{element.payment_type ? element?.payment_type : "-"}</td>
        <td>$ {Number(element.amount / 100)?.toFixed(2)}</td>
        <td className="text-capitalize"> {element.coupon ? element?.coupon : "-"}</td>
        <td className="space-nowrap text-nowrap">
          <Form className="switchbtn">
            <Badge bg={element?.is_paid ? "primary" : "danger"}>
              {element?.is_paid ? "Paid" : "Unpaid"}
            </Badge>
          </Form>
        </td>
        <td>{moment(element.created_at).format("LL HH:mm A")}</td>
      </tr>
    </>
  );
};

export default PaymentItems;
